'use strict';
(function defGroupsCollection(global) {

  /**
  * Часто используемые селекторы
  */
  const toolbarContentsSelector = '.toolbar_holder';
  const groupSelector = '.toolbar_group';
  const byNameSelectorTemplate = '{0}[name={1}]';
  //------------------------------------------------------------------------//

  /**
  * Обертка для коллекции кнопок
  * 
  * @class WebAccess.components.wrappers.toolBar.Groups
  * @extends WebAccess.Collecton
  * @since 5.2.0.1600
  */
  var Groups = global.Collection.extend({

    /**
    * Создает новую группу кнопок панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Groups#create
    * @param {string | object} toolGroupName Имя группы кнопок или объект {name: "", label:"", action:"", icon:""}
    * @param {string} toolGroupNameToAppendAfter Имя существующей группы кнопок на ленте, после которой вставится новая группа
    * @throws ERR_GROUP_NAME_IS_NOT_SPECIFIED_PROPERLY – Неверно указано имя группы.
    * @throws ERR_GROUP_WITH_THE_SAME_NAME_ALREADY_EXIST – Группа с указанным именем уже существует.
    * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    create(toolGroupName, toolGroupNameToAppendAfter) {
      const jToolBar = $(toolbarContentsSelector);

      const name = toolGroupName.name || toolGroupName;
      if (!name) {
        global.raise('ERR_GROUP_NAME_IS_NOT_SPECIFIED_PROPERLY');
      }

      const label = toolGroupName.label || L('NEW_GROUP');
      const icon = toolGroupName.icon || 'document-20';

      const jExistingGroup = $(format(byNameSelectorTemplate, groupSelector, name));
      if (jExistingGroup.length) {
        global.raise('ERR_GROUP_WITH_THE_SAME_NAME_ALREADY_EXIST', name);
      }

      // Разные шаблоны для группы с svg-иконкой и, ради совместимости, для группы с png-иконкой. Начиная с v5.6
      const groupTemplate = icon.endsWith('.png') ? ControlTemplate.toolBar.group : ControlTemplate.toolBar.groupSvg;
      const groupHtml = format(groupTemplate, name, label, icon);
      if (typeof toolGroupNameToAppendAfter === 'string') {
        if (toolGroupNameToAppendAfter === '') {
          jToolBar.prepend(groupHtml);
        } else {
          const jBeforeGroup = jToolBar.find(`[name="${toolGroupNameToAppendAfter}"]`);
          if (jBeforeGroup.length) {
            jBeforeGroup.after(groupHtml);
          } else {
            global.raise('ERR_SPECIFIED_BUTTONS_GROUP_DOES_NOT_EXIST');
          }
        }
      } else {
        jToolBar.append(groupHtml);
      }
      this.addElement(name, new global.components.wrappers.toolBar.ToolBarGroup(format(byNameSelectorTemplate, groupSelector, name)));
      return this[name];
    },
    //----------------------------------------------------------------------//

    /**
    * Проверяет наличие группы кнопок панели инструментов.
    *
    * @method WebAccess.components.wrappers.toolBar.Groups#isExist
    * @param {string} toolGroupName Имя группы кнопок
    * @return {boolean} True, если группа кнопок существует, иначе False.
    */
    isExist(toolGroupName) {
      const existingGroup = $(format(byNameSelectorTemplate, groupSelector, toolGroupName));
      return !!existingGroup.length;
    }
    //----------------------------------------------------------------------//
  });

  global.components.wrappers.toolBar.Groups = Groups;

})(window.WebAccess);